<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="crawlerVersionHour" clearable placeholder="输入采集小时">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="6" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt="">下载(带货架商品)</el-button>
        <el-button icon="el-icon-download" @click="exportSelectedJustLiveRooms" alt="">下载(仅直播间)</el-button>
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
        background
        @current-change="queryGoodsPage"
        layout="total, prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
        ref="dataTable"
        :data="liveRooms"
        style="width: 100%"
        @select="handleSelectionChange"
        @select-all="handleSelectAll"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期/小时/关键词">
          <template scope="scope">
             {{ scope.row.crawlerVersion }}/{{ scope.row.crawlerVersionHour }}/{{ scope.row.searchKeyword }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="authorDouId" label="直播间信息">
          <template scope="scope">
            房间ID:{{ scope.row.roomId }} <br />
            直播间标题:{{ scope.row.roomTitle }} <br />
            直播地址:{{ scope.row.roomLink }} <br />
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="主播信息">
          <template scope="scope">
            UID:{{ scope.row.userUid }} <br />
            昵称:{{ scope.row.userName }} <br />
            企业认证:{{scope.row.userEnterpriseVerifyReason}}<br />
            粉丝数:{{scope.row.userFansCount}}<br />
            关注数:{{scope.row.userFollowCount}}<br />
             <a target="blank" :href="scope.row.userPcProfileLink">个人主页</a><br />
          </template>
        </el-table-column>
        <el-table-column label="主播头像" width="100">
          <template scope="scope">
            <img
              :src="scope.row.userAvatar"
              width="70"
              height="70"
              class="head_pic"
            />
          </template>
        </el-table-column>
        <el-table-column label="查看货架" width="100">

        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
// const _ = require("lodash");
export default {
  name: "douyinLiveRooms",
  data() {
    return {
      liveRooms: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      crawlerVersionHour:null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=1";

      window.open("/api/douyin/export/liverooms?" + para);
    },
    exportSelectedJustLiveRooms() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=0";

      window.open("/api/douyin/export/liverooms?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.crawlerVersionHour != null && this.crawlerVersionHour != "") {
        para += "&crawlerVersionHour=" + this.crawlerVersionHour;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }


      axios
        .get("/api/douyin/queryPageLiveRooms?page=" + pageNum + "&pageSize=50" + para)
        .then((content) => {
          if (content.data.status.code === 0) {
            console.log(content.data.data)
            _this.liveRooms = content.data.data.liveRooms;
            _this.totalItems = content.data.data.total;
          }
        });
    },
  },
  mounted() {
    this.loadItemInfo(1);
  },
};
</script>
